import React from 'react'
import styles from './PublishDialog.scss'
import { Button } from 'common/Button'
import { CircleSpinner } from 'common/spinners'
import { Msg, commonVerbs } from 'lib/localization'
import { FormattedMessage as T } from 'react-intl'
const stopPropagation = (e) => e.stopPropagation()

export class PublishDialog extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      prevStatus: null,
      publishPending: null,
      error: null
    }
  }

  onChange = (publishStatus) => {
    this.setState({ publishStatus, publishPending: null })
  }

  onPublish = (publishStatus) => {
    const { onPublish, currentPublishStatus } = this.props
    this.setState({ publishPending: true, prevStatus: currentPublishStatus })
    // this is a little bit of a leaky abstraction here. If the Header gets more
    // complex in the future, it may make sense to move this logic into the
    // EditPage reducer
    onPublish(publishStatus)
      .then(_ => {
        this.setState({ publishPending: null, prevStatus: null })
      })
      .catch(e => {
        // TODO TODO global banner-based error handling
        this.setState({ error: 'Error updating report' })
      })
  }

  onPublishOnly = () => this.onPublish('everyone', false)

  onPublishAndSubmit = () => this.onPublish('everyone', true)

  onUnPublish = () => this.onPublish('draft', false)

  render () {
    const { publishPending, prevStatus, error } = this.state
    const { currentPublishStatus, reportSlug } = this.props

    const status = prevStatus || currentPublishStatus

    if (status !== 'draft') {
      return (
        <div className={styles.PublishDialog} onClick={stopPropagation}>
          <p><T id='PublishDialog.currentlyPublished' defaultMessage='Your report is currently published and visible on the site.' /></p>

          <Button type='default' className={styles.publishButton}>
            <a href={`/ride_reports/${reportSlug}`} target='_blank'><T id='PublishDialog.viewReport' defaultMessage='View Report' /> &raquo;</a>
          </Button>

          <Button
            type='danger'
            className={styles.unPublishButton}
            disabled={publishPending}
            onClick={!publishPending && this.onUnPublish}><Msg m={commonVerbs.unpublish} />
          </Button>

          {publishPending && <CircleSpinner size={20} className={styles.spinner} />}

          {error && <p className={styles.errorMsg}>{error}</p>}
        </div>
      )
    }

    return (
      <div className={styles.PublishDialog} onClick={stopPropagation}>
        <p><T id='PublishDialog.ready' defaultMessage='Ready to share your creation?' /></p>
        <Button
          type='default'
          className={styles.publishButton}
          disabled={publishPending}
          onClick={!publishPending && this.onPublishOnly}><T id='PublishDialog.publish' defaultMessage='Publish Report' />
        </Button>

        {publishPending && <CircleSpinner size={20} className={styles.spinner} />}

        {error && <p className={styles.errorMsg}>{error}</p>}
      </div>
    )
  }
}
